module.exports = __webpack_public_path__ + "img/Notisphere_Logo_Color_Dark.ced7c4d2.svg";